import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';
import { UserService } from '../../user/user.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const userService = inject(UserService);

    // Extract the module ID from the route data
    const requiredModuleId = route.data?.moduleId;

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const redirectURL =
                        state.url === '/sign-out'
                            ? ''
                            : `redirectURL=${state.url}`;
                    const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                    return of(urlTree);
                }

                // Check if the user is allowed to access the module
                const modules = userService.user?.modules || [];
                if (requiredModuleId && !modules.includes(requiredModuleId)) {
                    // Redirect to access denied or dashboard page
                    const urlTree = router.parseUrl('error/500');
                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            }),
        );
};
